import "./Hero.scss";

const Hero = () => {
  return (
    <div className="hero">
      <p className="hero__text">
        Web developer by day,
        <br /> baker by night.
      </p>
      <p className="hero__description">
        Low Key Bakerr is an in home baking company that provides
        <br />
        custom and staple items that are sure to impress!
      </p>
    </div>
  );
};

export default Hero;
